import ListDetailsClient from "./ListDetailsClient";
import DetailsEmpty from "./DetailsEmpty";
import ListDetailsOrder from "./ListDetailsOrder";
import ListDetailsActions from "./ListDetailsActions";
import ListDetailsNotes from "./ListDetailsNotes";
import {useTranslation} from "react-i18next";


const ListDetails = ({ order, onlyFood }) => {
    const { t } = useTranslation()
    if (!order || !order.id) return <DetailsEmpty />

    return (
        <>
            <div className="bg-white overflow-hidden sm:rounded-lg">

                <div className="flex justify-between items-center">
                    <div className="flex-grow {{ $order->statusColorClass() }} rounded p-2 mr-2">
                        <h2 className="font-bold {{ $order->statusTextColorClass() }}">{t('Order')} #{order.roid}</h2>

                        {order.pickupAt ? (
                            <div className="text-sm {{ $order->statusTextColorClass() }}">{t('Pickup at')} {order.pickupAt}</div>
                        ) :null}
                        <div className="text-sm {{ $order->statusTextColorClass() }}">{t('Status')}: {order.status}</div>
                    </div>

                    <ListDetailsActions order={order} />
                </div>

                {order.client ? (
                    <ListDetailsClient order={order} />
                ) : (
                    <ListDetailsNotes order={order} />
                )}
                <ListDetailsOrder order={order} onlyFood={onlyFood} />
            </div>
        </>
    )
}

export default ListDetails
